import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { CompileIconGray } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface EPControlAddedToScenarioProps {
  scenario: {
    id: string;
    name: string;
    assessmentId: string;
  };
  control: {
    id: string;
    name: string;
  };
  isToday?: boolean;
}

export const EPControlAddedToScenario: React.FC<EPControlAddedToScenarioProps> = ({ control, scenario, isToday }) => {
  const isPast = !isToday;

  return (
    <Base
      iconComponent={<CompileIconGray />}
      constentComponent={
        <Text $isPast={isPast}>
          Control{' '}
          <Link
            to={`/risk-management/control/${control.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Control'],
                  params: {
                    id: control.id,
                  },
                },
                tags: ['TIMELINE', 'RMP'],
              })
            }
          >
            <TextLink $isPast={isPast}>{control.name}</TextLink>
          </Link>{' '}
          added to Scenario{' '}
          <Link
            to={`/risk-assessments/${scenario.assessmentId}/scenario/${scenario.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Scenario'],
                  params: {
                    id: scenario.id,
                  },
                },
                tags: ['TIMELINE', 'RMP', 'SCENARIO'],
              })
            }
          >
            <TextLink $isPast={isPast}>{scenario.name}</TextLink>
          </Link>
          .
        </Text>
      }
    />
  );
};
